import { Component, inject, Input, Pipe, PipeTransform } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LanguagePrefixPipe } from '../pipes/language-prefix.pipe';
import { ImageBlockData, ImageBlockComponent } from './image-block.component';
import { SERVER_BASE_URL } from '../environment.token';
import { DomSanitizer } from '@angular/platform-browser';
import { InfoBlock } from 'apps/design4circularity/src/app/models';

@Pipe({ name: 'safeHtml', standalone: true })
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) { }
  transform(value?: string) {
    return value ? this.sanitized.bypassSecurityTrustHtml(value) : value;
  }
}

export interface InfoBlockData {
  cssClass: null | string;
  content: {
    image?: ImageBlockData;
    title: string;
    subtitle: string;
    richText: string;
    // button element indien label meegegeven wordt, anders wordt
    cta?: { label?: string } & (
      | { type: 'intern'; routerLink: string[] }
      | { type: 'extern'; href: string }
    );
  };
}

@Component({
  selector: 'ca-info-block',
  imports: [CommonModule, RouterModule, LanguagePrefixPipe, ImageBlockComponent, SafeHtmlPipe],
  template: `
<ng-template #projectedContent>
  <ng-content select="list-decorator"></ng-content>
</ng-template>

<ng-template #blockContent>
  @if (!hideImage && data.content.image; as img) { <ca-image-block [data]="img"></ca-image-block>}
  <div class="titelblock">
    <h2>{{ data.content.title }}</h2>
    <h3>{{ data.content.subtitle }}</h3>
  </div>
  <div class="textblock" [innerHTML]="data.content.richText | safeHtml"></div>
</ng-template>

<ng-template #ctaButton let-cta="cta">
  <a
    class="info-block-cta material-symbols-outlined"
    [routerLink]="cta.type === 'intern' ? cta.routerLink : null"
    [href]="cta.type === 'extern' ? cta.href : null">
    more_vert
  </a>
</ng-template>

<div
  [classList]="classList"
  [routerLink]="data && data.content && data.content.cta && data.content.cta.type === 'intern' ? (data.content.cta.routerLink | languagePrefix | async) : null"
  [attr.href]="data && data.content && data.content.cta && data.content.cta.type === 'extern' ? data.content.cta.href : null">
  <ng-container *ngTemplateOutlet="projectedContent"></ng-container>
  <ng-container *ngTemplateOutlet="blockContent"></ng-container>
  @if (data && data.content && data.content.cta) {
    <ng-container *ngTemplateOutlet="ctaButton; context: {cta: data.content.cta}"></ng-container>
  }
</div>
  `,
})
export class InfoBlockComponent {
  @Input() data!: Omit<InfoBlock, 'type'>;
  @Input() hideImage = false;
  get classList() {
    return 'info-block' + (this.data?.cssClass !== undefined && this.data?.cssClass !== null ? ' ' + this.data.cssClass : '') + (this.data?.content && this.data.content.cta ? ' router-link' : '')
  }
  readonly base = inject(SERVER_BASE_URL);
}
